import { render, staticRenderFns } from "./TabPane.vue?vue&type=template&id=0b8d7537"
import script from "./TabPane.vue?vue&type=script&lang=js"
export * from "./TabPane.vue?vue&type=script&lang=js"
import style0 from "./TabPane.vue?vue&type=style&index=0&id=0b8d7537&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports